module.exports = __webpack_public_path__ + "static/troll-bg-051a81eba2e3d9cc92ca150df2deb0f5.png";